import { useTranslation } from 'react-i18next';
import {
  StyledCheckIcon,
  StyledContainer,
  StyledPlusSign,
  StyledPlusText,
  StyledStack,
  StyledTypography,
  StyledWrapper,
} from './styled';

type PropsType = {
  handleScroll: () => void;
};

const DistroPlusAnchor = ({ handleScroll }: PropsType) => {
  const { t } = useTranslation();

  return (
    <StyledContainer>
      <StyledCheckIcon />
      <StyledWrapper onClick={handleScroll}>
        <StyledTypography>
          {t('subscription:pricing:includes')}
        </StyledTypography>
        <StyledStack>
          <StyledTypography>
            {t('distribution:upsellModal:labels:distro')}
          </StyledTypography>
          <StyledPlusText>
            {t('distribution:upsellModal:labels:plus')}
          </StyledPlusText>
          <StyledPlusSign>+</StyledPlusSign>
        </StyledStack>
      </StyledWrapper>
    </StyledContainer>
  );
};

export default DistroPlusAnchor;
